<template>
  <footer class="footer">
    {{ copyright }}
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    copyright: function () {
      return 'Copyright ' + new Date().getFullYear()
    }
  }
}
</script>

<style scoped>

.footer{
  background: #333;
  height: 80px;
  color: white;
  padding: 26px;
  position: fixed;
  bottom: 0;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/Footer.vue